import "../styleSheets/dashboardRecipients.css";
import "../styleSheets/buttons.css";
import "../styleSheets/commonElements.css";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import { useUser } from "../contexts/UserContext";
import {useRecipients, useUserPlan} from "../graphql/hooks";
import WidgetState from "./WidgetState";
import {TooltipButton} from "../utilities/ToolTipButton";

function DashboardRecipients() {
    const navigate = useNavigate();
    const {t} = useTranslation("common");
    const { user, isAuthenticated } = useUser();
    const userId = user?.userId ?? "";
    useEffect(() => {
        if(!isAuthenticated) {
            navigate("/", { state: { message:  t("common.signIn") }});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, navigate]);

    const {
        data: recipients = [],
        isLoading,
        isError,
        error,
    } = useRecipients(userId, isAuthenticated && !!userId);
    const planQ = useUserPlan(userId, isAuthenticated && !!userId);
    const userPlan = planQ.data;
    const recipientCount = recipients.length;
    const canCreateRecipients = Number(userPlan?.recipientsAllowed ?? 0) > recipientCount;

    if (!isAuthenticated) {
        navigate("/", {state: {message: t("common.signIn")}});
    }

    function addRecipient() {
        navigate("/RecipientEdit/", { state: null });
    }

    function seeAllRecipients() {
        navigate("/Panel?selectedTab=recipients");
    }

    return (
        <section className="section-recipients" aria-labelledby="recipients-heading">
            <section className={"files-header"}>
                <div className={"recipients-header-left"}>
                    <div className={"icon-container recipients-icon"}></div>
                    <h2 id="recipients-heading" className={"recipients-title"}>{t("recipient.myRecipients")}</h2>
                </div>

                <div className={"recipients-count"}>
                    {isLoading
                        ? t("common.loading")
                        : isError
                            ? "—"
                            : `${recipientCount} ${recipientCount === 1 ? t("recipient.recipient") : t("recipient.recipients")}`}
                </div>
            </section>

            <section className={"recipients-center"}>
                <WidgetState
                    isLoading={isLoading}
                    isError={isError}
                    error={error}
                    isEmpty={!isLoading && recipientCount === 0}
                    emptyText={t("recipient.onScreenMessage.noRecipients")}
                    className="recipients-subtitle"
                >
                    <div className={"recipients-subtitle"}>
                        {t("recipient.onScreenMessage.subTitle")}
                    </div>
                </WidgetState>
            </section>

            <section className={"recipients-bottom"}>
                <TooltipButton
                    label={"+ " + t("recipient.newRecipient")}
                    tooltip={t("recipient.errorMessage.planLimitReached")}
                    disabled={!canCreateRecipients}
                    onClick={addRecipient}
                    buttonClassName="btn btn--orange btn--size-md"
                />
                {recipientCount > 0 && (
                <button className={"btn btn--white btn--size-md"} onClick={seeAllRecipients}>
                    {t("common.seeAll")}
                </button>)}
            </section>
        </section>
    );

}

export default DashboardRecipients;
